<template>
  <v-container>
    <gridView v-if="edit" @editItem="editItem" />
    <formView v-else :identifier="identifier" @editItem="editItem" />
  </v-container>
</template>

<script>
import gridView from './grid'
import formView from './form'

export default {
  name: 'sequence',

  data: () => ({
    edit: true,
    key: null
  }),

  components: {
    gridView,
    formView
  },

  methods: {
    editItem (boolean, item) {
      this.edit = boolean
      this.identifier = item?.key.identifier
      this.clientPrefix = item?.key.clientPrefix
    }
  }
}
</script>
